import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SEATMAP_RESULT_STORE_NAME, SeatmapResultState } from './seatmap-result.state';

/** Select SeatmapResult State */
export const selectSeatmapResultState = createFeatureSelector<SeatmapResultState>(SEATMAP_RESULT_STORE_NAME);

/** Select SeatmapResult isPending status */
export const selectSeatmapResultIsPendingStatus = createSelector(
  selectSeatmapResultState,
  (state) => !!state.isPending
);

/** Select SeatmapResult isFailure status */
export const selectSeatmapResultIsFailureStatus = createSelector(
  selectSeatmapResultState,
  (state) => !!state.isFailure
);
